import { environment } from './environment'
import { trimSpaces } from './utils'

const assetName = environment.assetName
const considerTheseInternal = environment.internalDomains

export const extractAnalyticsText = (children, text, ariaLabel, component) => {
  let analyticsText = text
  if (!analyticsText) {
    // No text, try and get it from the children
    if (children) {
      if (typeof children === 'string') {
        analyticsText = children
      } else {
        // Children is an object.
        if (Array.isArray(children)) {
          // This is something like <span>A</span><span>B</span> being passed
          for (let i = 0; i < children.length; i++) {
            if (children[i].props.children) {
              analyticsText = children[i].props.children
              break
            }
          }
        } else {
          // This is something like <span>A</span> being passed
          analyticsText = children.props.children
        }
      }
    }
    // If we've still got no text then try ariaLabel
    if (!analyticsText) {
      analyticsText = ariaLabel
    }
    // If no text here then we've failed
    if (!analyticsText && environment.warnAnalytics) {
      console.warn(`${component} failed analytics check. No text found`, {
        children,
        text,
        ariaLabel,
        component
      })
    }
  }

  return analyticsText
}

export const isInternalLink = (h) => {
  if (!h) {
    return true
  }
  // Treat local links as internal links
  if (h === '#' || h.startsWith('/') || h.startsWith('./')) {
    return true
  }
  // Check domain
  const internalLinkRegex = considerTheseInternal.replace(/\./g, '[.]')
  const comp = new RegExp(internalLinkRegex)
  return comp.test(h)
}

export const sendAnalytics = (action, actionType, text, url, currentScreen) => {
  text = trimSpaces(text)

  const oA = {
    assetName, // Unique name of the asset
    action, // What kind of action is it {Click, Slide/Swipe, Pagination etc}
    actionType, // Define the type of the action {If Click, is it Internal, External, Hash or Popup} {If Slide/Swipe, is it Next or Previous}
    text, // Text on the user actionable item {In case if it is a carousal, the title of the slide/card if Slide/Swidpe action}
    url: url == null ? '' : url,
    currentScreen
  }

  console.log('Analytics', oA)
  if (document.referrer !== '' && text) {
    window.top.postMessage(oA, '*')
  }
}

export const sendClickInternalOrExternal = (text, url, currentScreen) => {
  if (url === '#') {
    console.log('No analytics for #. Hash should be sent elsewhere')
  } else if (isInternalLink(url)) {
    // Send only pathname in this case
    const oUrl = new URL(url)
    sendAnalytics('Click', 'Internal', text, oUrl.pathname, currentScreen)
  } else {
    sendAnalytics('Click', 'External', text, url, currentScreen)
  }
}

export const sendClickHash = (text, url, currentScreen) => {
  sendAnalytics('Click', 'Hash', text, url, currentScreen)
}

export const sendClickPopup = (text, url, currentScreen) => {
  sendAnalytics('Click', 'Popup', text, url, currentScreen)
}

export const sendClickTab = (text, url, currentScreen) => {
  sendAnalytics('Click', 'Tab', text, url, currentScreen)
}

export const sendClickAccordion = (text, url, currentScreen, isExpanded) => {
  sendAnalytics('Click', isExpanded, text, url, currentScreen)
}

export const sendClickDownload = (text, url, currentScreen) => {
  sendAnalytics('Click', 'Download', text, url, currentScreen)
}

export const sendSlideSwipe = (direction, text, currentScreen) => {
  sendAnalytics('Slide/Swipe', direction, text, '', currentScreen)
}

export const sendMediaProgress = (audioOrVideo, progress, videoTitle) => {
  if (audioOrVideo !== 'Audio' && audioOrVideo !== 'Video') {
    console.warn('Analytics:sendMediaProgress: audioOrVideo should be either Audio or Video')
  }
  sendAnalytics(`${audioOrVideo} Play`, progress, videoTitle, '', '')
}
